<script setup>
import { ref, onUpdated, defineProps, defineEmits } from "vue"
import useStores from "../../use/useStores"
import usePersianTools from "../../use/usePersianTools"

const props = defineProps({
  storeProps: {
    required: true,
    type: Object,
  },
})

const storeData = ref({
  id: props.storeProps.id,
  first_name: props.storeProps.name,
  phone_number: props.storeProps.phone,
  email: props.storeProps.email,
  password: "",
  password_confirmation: "",
  status: props.storeProps.status,
})

const emit = defineEmits(["update:modelValue", "close"])

const { show, loading, errors, onSubmit, closeModal } = useStores(
  props,
  emit,
  storeData
)

const { convertPersianToEnglish } = usePersianTools()

onUpdated(() => {
  storeData.value = {
    id: props.storeProps.id,
    first_name: props.storeProps.name,
    phone_number: props.storeProps.phone,
    email: props.storeProps.email,
    password: "",
    password_confirmation: "",
    status: props.storeProps.status,
  }
})
</script>

<template>
  <!-- add and edit store modal  -->
  <b-modal
    v-model="show"
    @close="closeModal()"
    id="showModal"
    hide-footer
    title=" افزودن فروشگاه"
    header-class="p-3 bg-light"
    class="v-modal-custom"
    centered
    no-close-on-backdrop
  >
    <b-overlay
      variant="white"
      opacity="0.75"
      blur="2px"
      :show="loading"
      spinner-variant="success"
      rounded="sm"
    >
      <b-card>
        <b-form
          id="addform"
          class="tablelist-form"
          autocomplete="off"
          @submit.prevent="onSubmit"
        >
          <div class="mb-3">
            <label for="storename" class="form-label"> نام</label>
            <input
              type="text"
              id="storename"
              class="form-control"
              placeholder="نام فروشگاه"
              v-model="storeData.first_name"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.first_name">
                <span>{{ errors.first_name[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="email" class="form-label">ایمیل</label>
            <input
              type="email"
              id="email"
              class="form-control"
              placeholder="آدرس ایمیل فروشگاه"
              v-model="storeData.email"
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.email">
                <span>{{ errors.email[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <label for="phone" class="form-label">تلفن</label>
            <input
              type="tel"
              id="phone"
              class="form-control"
              placeholder="شماره تلفن فروشگاه"
              v-model="storeData.phone_number"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  storeData,
                  'phone_number'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.phone_number">
                <span>{{ errors.phone_number[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3" v-if="!storeData.id">
            <label for="password" class="form-label">کلمه عبور</label>
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="کلمه عبور (پسورد)"
              v-model="storeData.password"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  storeData,
                  'password'
                )
              "
            />
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.password">
                <span>{{ errors.password[0] }}</span>
              </div>
            </div>
          </div>

          <div class="mb-3" v-if="!storeData.id">
            <label for="confirm-password" class="form-label"
              >تایید کلمه عبور</label
            >
            <input
              type="password"
              id="confirm-password"
              class="form-control"
              placeholder="تایید کلمه عبور (تکرار کلمه عبور)"
              v-model="storeData.password_confirmation"
              @input="
                convertPersianToEnglish(
                  $event.target.value,
                  storeData,
                  'password_confirmation'
                )
              "
            />
          </div>

          <div class="mb-3">
            <label for="status" class="form-label">وضعیت</label>
            <select
              class="form-control"
              data-trigger
              id="statusfield"
              v-model="storeData.status"
            >
              <option value="">وضعیت</option>
              <option value="0">غیرفعال</option>
              <option value="1">فعال</option>
            </select>
            <div v-if="errors">
              <div class="invalid-feedback" v-if="errors.status">
                <span>{{ errors.status[0] }}</span>
              </div>
            </div>
          </div>

          <div class="hstack gap-2 justify-content-end">
            <b-button
              type="button"
              id="closemodal"
              variant="light"
              @click="closeModal"
            >
              بستن
            </b-button>
            <b-button type="submit" variant="success">
              {{ storeData.id ? "ویرایش فروشگاه" : "افزودن فروشگاه" }}
            </b-button>
          </div>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
